import { combineReducers } from 'redux';
import { reducer as responsiveReducer } from 'react-responsive-redux';
import authComponent from './manageAuthButtonStatus';
import privacyCheckbox from './managePrivacyCheckboxStatus';
import marketingCheckbox from './manageMarketingCheckboxStatus';
import cartItems from './manageCartItems';
import api from './api';
import numCartItems from './manageNumCartItems';
import countryCode from './manageCountryCode';
import overflowScroll from './manageOverflowScroll';
import department from './manageDepartment';
import scrollPosition from './manageScrollPosition';
import isChangeShippingCountryVisible from './manageChangeShippingCountrySelector';
import isFiltersModalVisible from './manageFiltersModal';
import featuredImgNumber from './manageFeaturedImgNumber';
import authStatus from './manageAuthStatus';
import modals from './manageModal';

const rootReducer = combineReducers({
  api,
  authComponent,
  authStatus,
  cartItems,
  countryCode,
  footerWrapper: scrollPosition,
  marketingCheckbox,
  numCartItems,
  overflowScroll,
  department,
  privacyCheckbox,
  scrollPosition,
  isFiltersModalVisible,
  isChangeShippingCountryVisible,
  responsive: responsiveReducer,
  featuredImgNumber,
  modals,
});

export default rootReducer;
